<template>
    <div class="sieve-single-center">
        <el-main v-loading="mainLoading"
                 class="main-loading">
            <m-pane ref="tablePage"
                    :columnNum="columnNum"
                    :config="config"
                    :endMoveHeight="endMoveHeight"
                    :isRefreshTarget="true"
                    :loading="loading"
                    :mulSourceSel="true"
                    :optionNum="optionNum"
                    :pageTotal="pageTotal"
                    :searchTotalTitle="searchTotalTitle"
                    :sourceRootData="sourceTree"
                    :sourceTitle="sourceTitle"
                    :targetRootData="targetTree"
                    :targetTableLoading="targetTableLoading"
                    :targetTitle="targetTitle"
                    :totalData="totalData"
                    :totalTargetData="totalTargetData"
                    :verification="verification"
                    pageID="train-list-adjust"
                    moduleCode="RE5448775352406016-1"
                    searchId="train-list-adjust-query"
                    @getTableConfigList="getTableConfigList"
                    @searchSet-change="searchSetChange"
                    @searchChange="searchChange"
                    @sourceCellDblclick="sourceCellDblclick"
                    @sourceRowClick="sourceRowClick"
                    @sourceSelect="sourceSelect"
                    @sourceSelectAll="sourceSelectAll"
                    @root-click="rootClick"
                    @source-select-change="sourceSelChange"
                    @search-input="searchInput">
                <span slot="search-list-advance-right">
                    <span v-show="checkedSourceList.length"
                          class="left-info collect">
                        <span>单量：<span class="content">{{
                            filterCheckedSourceListCount
                                }}</span></span>
                        <span>数量：<span class="content">{{
                            taskTotalCount
                                }}</span></span>
                        <span>方量(m³)：<span class="content">{{
                            taskTotalVolume
                                }}</span></span>
                        <span>重量(KG)：<span class="content">{{
                            taskTotalWeight
                                }}</span></span>
                        <span v-show="totalPkgQtys">总包件数：<span class="content">{{
                            totalPkgQtys
                                }}</span></span>
                    </span>
                </span>
                <div slot="table-module-btn"
                     class="table-module-btn"></div>
                <div slot="target-table-header"
                     class="target-table-header"
                     @mousedown.stop.prevent="mousedownTabelHeight"></div>
                <div slot="expand-table-cont"
                     slot-scope="{ expandTable }">
                    <expand-table-content :columnsList="expandTableHeader"
                                          :contentTableData="expandTable"></expand-table-content>
                </div>
            </m-pane>
        </el-main>
    </div>
</template>
<script>
import _ from 'lodash';
import mPane from './mPanel';
import config from './sieveSingleConfig.json';
import ExpandTableContent from './ExpandTableContent';
import { dictWithUrl } from '@/components/lots/api.js';
import { queryGroup, queryByGroup, getNewSourceRoot, getNewSourceData, getSiteCodeList, getLayerIdListApi } from '@/modules/transport/otp/api/loadAdjustmentTable';
import { mapState } from 'vuex';
import { groupPolicyObj, minusVerifyLBXOrder } from '@/modules/transport/otp/utils/dispatchCenter.js';
import formatTime from '@/utils/common.js';
import { formatSetSearchTime } from './util.js';

export default {
    name: 'sieveSingleCenter',
    props: ['QCO'],
    components: {
        mPane,
        ExpandTableContent
    },
    data () {
        return {
            revocationShow: false,
            checkedSourceList: [],
            cheList: [],
            flag: '',
            currentRow: null,
            allocateData: [],
            tempTargetTree: [],
            config: config,
            loading: false,
            groupPolicy: '',
            groupPolicyCode: '',
            groupPolicyValArr: [],
            targetTableLoading: false,
            sourceTitle: '待调度',
            sourceTree: [],
            targetTree: [],
            sourceSelectedRoot: {},
            tarSelRoot: {},
            targetCanSort: true,
            optionNum: 'DELIVERY_TYPE,TRANSPORT_STATUS,OTP_TMS_PROCUREMENT_CHANNEL',
            totalData: [], // 页面展示的上表格数据
            mulTotalData: [], // 真正的上表格数据
            targetTaskNoSet: new Set(), // 目标运单任务任务号集合
            totalDataFirst: [],
            totalTargetData: [], // 下表格数据
            realTotalTargetData: [], // 真正的下表格数据
            targetIsAllSel: false, // 下表格是否点击全选，因为有天猫优品勾选一单选中所有相同客户订单号只展示100单判断真实选中会不准确
            sourceIsAllSel: false, // 同上，上表格类似逻辑
            pageTotal: 100,
            emergencyMaxNum: '',
            searchParams: {},
            searchTotalTitle: config.table.searchTotalTitle,
            arrangeForm: { procurementChannel: '' },
            verification: {},
            expandTableHeader: [
                { label: '客户商品编码', prop: 'customerItemCode', width: 180 }, { label: '商品编码', prop: 'itemCode', width: 180 },
                { label: '名称', prop: 'itemName', width: 180 }, {
                    label: '商品分类名称',
                    prop: 'itemClassName',
                    width: 180
                }, { label: '预计发数量', prop: 'unitQty', width: 100 },
                { label: '商品重量', prop: 'weight', width: 100 }, { label: '商品方量', prop: 'volume', width: 100 }
            ],
            startMove: 0,
            endMove: 0,
            endMoveHeight: 0,
            rowData: {},
            mainLoading: false,
            transferDisable: false,
            confirmDisable: false,
            sourceTableDom: '',
            targetTableDom: '',
            targetTotalListPage: {
                pageNo: 1,
                pageSize: 1000000,
                total: 0
            },
            targetTotalListParams: {
                dispatchStatus: '0,6,10,20,30'
            },
            columnNum: 15,
            currentSelectRow: {},
            currentSourceSelectRow: {},
            timerAllDiff: '',
            timerDragLoad: '',
            timerUpDrag: '',
            timerFinalDeliveryType: '',
            isFirstSearch: true,
            serveRule: []
        };
    },
    computed: {
        realCheckedSourceList: function () {
            if (this.checkedSourceList.length === this.totalData.length && this.sourceIsAllSel) {
                return this.mulTotalData;
            }
            return minusVerifyLBXOrder(this.checkedSourceList, this.mulTotalData);
        },
        realCheList: function () {
            if (this.cheList.length === this.totalTargetData.length && this.targetIsAllSel) {
                return this.realTotalTargetData;
            }
            return minusVerifyLBXOrder(this.cheList, this.realTotalTargetData);
        },
        taskTotalVolume: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.totalVolume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        taskTotalWeight: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.totalGrossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        taskTotalCount: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalCount = partical + (value.totalQty || 0);
                return Math.round(taskTotalCount * 1000) / 1000;
            }, 0);
        },
        filterCheckedSourceListCount: function () {
            return this.realCheckedSourceList.length;
        },
        targetTitle: function () {
            return `待发车(${this.targetTree.length || 0})`;
        },
        currInOutType: function () {
            return this.totalTargetData[0] && this.totalTargetData[0].inOutType;
        },
        totalPkgQtys: function () {
            return this.checkedSourceList.reduce((partical, value) => {
                if (value.projectClassify === 'HL') {
                    const totalPkgQtys = partical + (value.totalPkgQty || 0);
                    return Math.round(totalPkgQtys * 1000) / 1000;
                }
            }, 0);
        },
        ...mapState({ user: state => state.user, supplier: state => state.supplier })
    },
    async mounted () {
        this.getDictList();
        if (this.QCO !== 'QCO') {
            await this.getSiteCodeList();
            const initSearchInfo = localStorage.getItem(this.user.userCode + 'searchInfo');
            if (initSearchInfo) {
                this.handleInitData(initSearchInfo);
            }
        }
    },
    methods: {
        /**
         * @description 上次保存的查询条件回显
         * @param {Object} data 查询条件
         */
        handleInitData (data) {
            const setSearchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData;
            const searchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].searchData || {};
            const searchList = JSON.parse(data);
            delete searchList.createTime;
            // 查询条件赋值
            Object.keys(searchList).filter(v => setSearchData.hasOwnProperty(v)).forEach(item => {
                setSearchData[item] = searchList[item];
            });
            // 高级查询赋值
            Object.keys(searchList).forEach(item => {
                searchData[item] = searchList[item];
            });
        },
        // 查询配置的服务平台
        async getSiteCodeList () {
            const res = await getSiteCodeList({ userCode: this.user.userCode });
            if (res && +res.code === 0) {
                this.siteCodeList = res.data.siteCodeList || [];
                this.getLayerIdList();
            }
        },
        getLayerIdList (siteCodeList) {
            const data = { siteCodeList: siteCodeList };
            getLayerIdListApi(data).then(res => {
                if (res && +res.code === 0) {
                    const option = [];
                    res.data.forEach(v => {
                        option.push({ 'value': v.id, 'label': v.preLayerName });
                    });
                    const targetConfig = this.config.searchList.searchTxt.find(item => item.value === 'layerIdList');
                    if (targetConfig) {
                        targetConfig.options = option;
                    }
                }
            });
        },
        searchSetChange (data) {
            // 地图排车加单预设区域级联服务平台
            if (this.QCO === 'QCO'&& data.siteCode) {
                // 重选服务平台清空预设区域的值
                this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.layerIdList = [];   
                this.getLayerIdList(data.siteCode.split(','));
            }
        },
        // 过滤掉已经添加的运单
        tlSetTargetTaskNoSet (taskNoSet) {
            this.targetTaskNoSet = taskNoSet;
            this.totalData = this.getTotalData(this.mulTotalData.filter(t => !taskNoSet.has(t.taskNo)));
        },
        // 返回 选择的的行
        tlGetSelectedRows () {
            return this.checkedSourceList;
        },
        // 返回 所有的行
        tlGetAllRows () {
            return this.mulTotalData.filter(t => !this.targetTaskNoSet.has(t.taskNo));
        },
        refreshList (visiable) {
            if (visiable) {
                this[visiable] = false;
            }
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        leftList () {
            this.totalData = [];
            this.totalTargetData = [];
            this.mulTotalData = [];
            this.realTotalTargetData = [];
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        async getDictList () {
            await dictWithUrl(this.optionNum);
        },
        async initTableData (initData) {
            const dict = await dictWithUrl('OTP_TMS_PROCUREMENT_CHANNEL,TRANSPORT_STATUS,ORDER_TYPE,DELIVERY_TYPE,PROJECT_CLASSIFY,TASK_TYPE,SOURCE_SYSTEM,WMS_STATUS');
            const dictData = dict.data;
            initData.forEach(item => {
                item.supplierReserveFlagName = item.supplierReserveFlag === 'Y' ? '是' : '否';
                item.procurementChannelName = dictData.OTP_TMS_PROCUREMENT_CHANNEL[item.procurementChannel] || item.procurementChannel;
                item.distributionFlagName = item.distributionFlag === 'Y' ? '是' : '否';
                item.distributionContinueFlagName = item.distributionContinueFlag === 'Y' ? '是' : '否';
                item.carrierVisibleFlagName = item.carrierVisibleFlag === 'Y' ? '是' : '否';
                item.collectionFlagName = item.collectionFlag === 'Y' ? '是' : '否';
                item.isJzpName = item.isJzp === 'Y' ? '是' : '否';
                item.deliverypayTypeName = +item.deliverypayType === 2 ? '到付' : '寄付';
                item.scPosFlagName = +item.scPosFlag === 0 ? '否' : (+item.scPosFlag === 1 ? '是' : item.scPosFlag);
                item.cnDispatchName = +item.cnDispatch === 0 ? '否' : (+item.cnDispatch === 1 ? '是' : item.cnDispatch);
                item.intelligentStatusName = +item.intelligentStatus === 0 ? '未智能调度' : (+item.intelligentStatus === 1 ? '智能调度成功' : '智能调度失败');
                item.planOrderFlagName = +item.planOrderFlag === 1 ? '是' : '否';
                item.logisticModeName = item.logisticMode === 'WT' ? '是' : '否';
                item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus] || item.taskStatus;
                item.orderTypeName = dictData.ORDER_TYPE[item.orderType] || item.orderType;
                if (item.sourceSystem === 'CAINIAO' && item.orderType === 'YS' && +item.serviceType === 8) {
                    item.orderTypeName = '逆向运输';
                }
                item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType] || item.deliveryType;
                item.projectClassifyName = dictData.PROJECT_CLASSIFY[item.projectClassify] || item.projectClassify;
                item.taskTypeName = dictData.TASK_TYPE[item.taskType] || item.taskType;
                item.sourceSystemName = dictData.SOURCE_SYSTEM[item.sourceSystem] || item.sourceSystem;
                item.appointTimeFlag = item.appointmentTime ? '是' : '否';
                item.wmsStatusName = dictData.WMS_STATUS[item.wmsStatus] || '待作业';
                if (item.transportDetails && item.transportDetails.length > 0) {
                    const splitArr = item.transportDetails[0].itemClassName ? item.transportDetails[0].itemClassName.split('.') : [];
                    splitArr.shift();
                    item.itemClassName = splitArr.join('.');
                }
                item.arriveAppointmentRequireFlagName = +item.arriveAppointmentRequireFlag === 2 ? '是' : '否';
            });
            return initData;
        },
        initTransportList (scroll) {
            this.$refs.tablePage.sourceLoading = true;
            this.searchParams['carrierVisibleFlag'] = 'Y';
            this.searchParams['carrierCode'] = this.supplier.supplierCode;
            this.searchParams['carrierName'] = this.supplier.supplierNameCn;
            const data = Object.assign({}, this.searchParams, { pageSize: 1000 });
            groupPolicyObj.forEach(item => {
                if (item.name === this.groupPolicy) {
                    this.groupPolicyCode = item.code;
                    data[item.code] = this.sourceSelectedRoot[item.code] || '';
                }
            });
            if (this.QCO === 'QCO') {
                getNewSourceData(data).then(async resp => {
                    this.$refs.tablePage.sourceLoading = false;
                    if (resp) {
                        this.sourceSelectedRoot.isActive = !this.sourceSelectedRoot.isActive;
                        const resData = resp.data.list || [];
                        if (this.sourceSelectedRoot.isActive) {
                            this.mulTotalData = this.mulTotalData.concat(resData);
                        } else {
                            const resDataGroupPolicyCodeSet = new Set(resData.map(el => el[this.groupPolicyCode]));
                            this.mulTotalData = this.mulTotalData.filter(el => !resDataGroupPolicyCodeSet.has(el[this.groupPolicyCode]));
                        }
                        // 过滤掉目标表格中的数据
                        this.mulTotalData = this.mulTotalData.filter(el => !this.targetTaskNoSet.has(el.taskNo));
                        this.mulTotalData = await this.initTableData(this.mulTotalData);
                        this.totalData = this.getTotalData(this.mulTotalData);
                    }
                }).catch(() => {
                    this.$refs.tablePage.sourceLoading = false;
                });
            } else {
                queryByGroup(data).then(async resp => {
                    this.$refs.tablePage.sourceLoading = false;
                    if (resp) {
                        this.sourceSelectedRoot.isActive = !this.sourceSelectedRoot.isActive;
                        const resData = resp.data.list || [];
                        if (this.sourceSelectedRoot.isActive) {
                            this.mulTotalData = this.mulTotalData.concat(resData);
                        } else {
                            const resDataGroupPolicyCodeSet = new Set(resData.map(el => el[this.groupPolicyCode]));
                            this.mulTotalData = this.mulTotalData.filter(el => !resDataGroupPolicyCodeSet.has(el[this.groupPolicyCode]));
                        }
                        // 过滤掉目标表格中的数据
                        this.mulTotalData = this.mulTotalData.filter(el => !this.targetTaskNoSet.has(el.taskNo));
                        this.mulTotalData = await this.initTableData(this.mulTotalData);
                        this.totalData = this.getTotalData(this.mulTotalData);
                    }
                }).catch(() => {
                    this.$refs.tablePage.sourceLoading = false;
                });
            }
        },
        getTotalData (totalData) {
            return totalData;
        },
        emergencyMaxNumChange (value) {
            this.leftList();
            this.emergencyMaxNum = value;
        },
        async searchChange (data) {
            if (data.createTime && data.createTime.length > 0) {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
            } else if (!data.createTime && !data.beginDate) {
                data.beginDate = '';
                data.endDate = '';
            }
            data.custOrderNos = data.custOrderNo ? data.custOrderNo.split(',') : [];
            data.taskNos = data.taskNo ? data.taskNo.split(',') : [];
            const startTime = data.beginDate || 0;
            const endTime = data.endDate || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!data.custOrderNos.length && !startTime) {
                return this.$message.warning('客户订单号 和 创建时间 不可同时为空');
            } else if (!data.custOrderNos.length && startTime) {
                if (timeDifference > 32 * 24 * 60 * 60 * 1000) {
                    return this.$message.warning('按时间查询时，查询时间跨度不可超过一个月！');
                }
            }
            if (data.custOrderNos.length > 100) return this.$message.warning('客户订单号批量查询时，最多只能同时查100条数据！');
            if (data.taskNos.length > 100) return this.$message.warning('运输单号批量查询时，最多只能同时查100条数据！');
            this.totalData = [];
            this.mulTotalData = [];
            data.customerCodes = data.customerCode ? data.customerCode.split(',') : [];
            data.whCodes = data.whCode ? data.whCode.split(',') : [];
            data.orderWhCodes = data.orderWhCode ? data.orderWhCode.split(',') : [];
            data.siteCodes = data.siteCode ? data.siteCode.split(',') : [];
            if (data.groupPolicy) this.groupPolicy = data.groupPolicy;
            data.taskStatus = '0';
            delete data.custOrderNo;
            delete data.createTime;
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            this.isFirstSearch = false;
            this.$refs.tablePage.changeLoading(true);
            this.$refs.tablePage.sourceTreeLoading = true;
            this.$refs.tablePage.targetTreeLoading = true;
            if (this.QCO === 'QCO') {
                // siteCode => querySiteCodes
                if (this.searchParams.siteCode) {
                    this.searchParams.querySiteCodes = this.searchParams.siteCode.split(',');
                } else {
                    this.searchParams.querySiteCodes = [];
                }
                this.searchParams['carrierVisibleFlag'] = 'Y';
                this.searchParams['carrierCode'] = this.supplier.supplierCode;
                this.searchParams['operateSystem'] = 'LSP'
                this.searchParams['mapFlag'] = '1'
                delete this.searchParams.siteCodes;
                delete this.searchParams.siteCode;
                await getNewSourceRoot(this.searchParams).then(resp => {
                    this.$refs.tablePage.changeLoading(false);
                    this.$refs.tablePage.sourceTreeLoading = false;
                    if (resp) {
                        const sourceTree = resp.data.list;
                        if (sourceTree) {
                            sourceTree.forEach(root => {
                                root.isActive = false;
                                root['textLeft'] =
                                    `${root[this.groupPolicy] ? root[this.groupPolicy] : ' '} ${root.totalVolume || ''}m³/${root.totalWeight || ''}KG/${root.totalQty || ''}台/${root.taskCount || ''}单`;
                            });
                        }
                        this.sourceTree = sourceTree;
                    }
                }).catch(() => {
                    this.$refs.tablePage.changeLoading(false);
                    this.$refs.tablePage.sourceTreeLoading = false;
                });
            } else {
                await queryGroup(this.searchParams).then(resp => {
                    this.$refs.tablePage.changeLoading(false);
                    this.$refs.tablePage.sourceTreeLoading = false;
                    if (resp) {
                        const sourceTree = resp.data.list;
                        if (sourceTree) {
                            sourceTree.forEach(root => {
                                root.isActive = false;
                                root['textLeft'] =
                                    `${root[this.groupPolicy] ? root[this.groupPolicy] : ' '} ${root.totalVolume || ''}m³/${root.totalWeight || ''}KG/${root.totalQty || ''}台/${root.taskCount || ''}单`;
                            });
                        }
                        this.sourceTree = sourceTree;
                        // 获取当前查询条件
                        const searchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet;
                        const conditionList = JSON.stringify(Object.assign({}, searchData[0].searchData, formatSetSearchTime(searchData[0].setSearchData)));
                        window.localStorage.setItem(this.user.userCode + 'searchInfo', conditionList);
                    }
                }).catch(() => {
                    this.$refs.tablePage.changeLoading(false);
                    this.$refs.tablePage.sourceTreeLoading = false;
                });
            }

            this.$refs.tablePage.initActiveChange();
        },
        getTableConfigList (data) {
        },
        rootClick (item, to) {
            if (to === 'source') {
                this.sourceSelectedRoot = item;
                this.initTransportList();
            }
        },
        sourceSelChange (selection) {
            this.checkedSourceList = selection;
            const selctedTaskNos = this.checkedSourceList.map(item => item.taskNo);
            this.currentSourceSelectRow.checked = selctedTaskNos.includes(this.currentSourceSelectRow.taskNo);
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(this.currentSourceSelectRow, moduleTable);
        },
        sourceSelectAll (selection) {
            this.sourceIsAllSel = true;
        },
        sourceSelect (selection, row) {
            this.sourceIsAllSel = false;
            this.currentSourceSelectRow = row;
        },
        sourceRowClick (row) {
            this.sourceIsAllSel = false;
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(row, moduleTable);
        },
        checkSameLbxOrder (row, moduleTable) {
            // 天猫优品的单勾选一条相同客户订单号的全部选中（展示中的数据）
            if (row.businessMode === 'B2B' && ['OUT', 'DO'].includes(row.taskType) && row.sourceSystem === 'CAINIAO') {
                const sameLbxOrder = moduleTable.tableData.filter(item => item.customerOrderNo === row.customerOrderNo);
                sameLbxOrder.forEach(item => {
                    moduleTable.toggleRowSelection(item, row.checked);
                });
            }
        },
        searchInput (input, ev, isClick) {
            const inputVal = input.trim();
            const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
            if (!inputVal) {
                this.targetTotalListParams.dispatchNo = '';
                this.targetTotalListParams.vehicleCard = '';
            } else if (reg.test(inputVal)) {
                this.targetTotalListParams.dispatchNo = '';
                this.targetTotalListParams.vehicleCard = inputVal;
            } else {
                this.targetTotalListParams.dispatchNo = inputVal;
                this.targetTotalListParams.vehicleCard = '';
            }
        },
        mousedownTabelHeight (e) {
            this.startMove = e.clientY;
            var distance = 0;
            document.onmousemove = (ev) => {
                var thisEvent = ev || event;
                distance = this.startMove - thisEvent.clientY;
                this.endMove = distance;
                this.$refs.tablePage.targetTableEndMove(this.endMove);
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                this.endMoveHeight = this.endMoveHeight + distance;
            };
        },
        copyText (cellEl, copyText, classFlag) {
            if (cellEl.className.indexOf('el-tooltip') < 0 && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        sourceCellDblclick (row, column, cell, event) {
            this.copyText(cell.children[0], cell.children[0].innerHTML, true);
        }
    }
};
</script>
<style lang="less">
@import './sieveSingleCenter.less';
</style>
